import React from 'react';
import { injectV2 } from '../../../../injectV2';
import { RouteLocation } from '../../../../stores/routes/createRoute';
import { SeoLink } from '../../../SeoLink/SeoLink';
import { useScrollToTop } from '../../../../contexts/ScrollToTopContext';
import { UiLoggerStore } from '../../../../stores/UiLoggerStore';
import { BaseURLStore } from '../../../../stores/BaseURLStore';
import s from './CategoriesListItem.scss';
import { categoriesListItemDataHooks } from './CategoriesListItem.dataHooks';

export interface CategoryProps {
  location: RouteLocation;
  title: string;
  slug: string;
  dataHook?: string;
  uiLoggerStore: UiLoggerStore;
  baseURLStore: BaseURLStore;
}

const CategoryTagCmp: React.FC<CategoryProps> = (props) => {
  const { location, title, dataHook, uiLoggerStore, baseURLStore, slug } = props;
  const { scrollToTop } = useScrollToTop();

  const handleItemClick = (event: React.MouseEvent) => {
    scrollToTop();
    event.stopPropagation();
    uiLoggerStore.logClickElement({
      clicked_element: 'browse category',
      clicked_element_identifier: slug,
      openingBrowserUrl: baseURLStore.buildURL(location),
      category: null,
      subCategory: null,
    });
  };

  return (
    <li data-hook={dataHook} className={s.item}>
      <SeoLink
        className={s.category}
        to={location}
        dataHook={categoriesListItemDataHooks.link()}
        onClick={(event) => handleItemClick(event)}
      >
        {title}
      </SeoLink>
    </li>
  );
};

export const CategoriesListItem = injectV2('uiLoggerStore', 'baseURLStore')(CategoryTagCmp);
